<template>
    <div class="partners-section">
        <div class="container">
            <div class="title">
                <h2>
                    Encontre parceiros com o mesmo propósito que você.
                </h2>
            </div>

            <div class="row">
                <div class="col-4 col-md-2" v-for="(item, index) in getPartnersData" :key="`partner-${index}`">
                    <div class="info-item" data-aos="zoom-in">
                        <img :src="require(`@/assets/img-section2-${item.img}.svg`)" alt="" />

                        <h5 class="text" v-if="item.img !== '18'">{{ item.quantity }} cadastros</h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PartnersSection',
    props: {
        partnersData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            imgListSection2: {
                1: { img: '1', quantity: 0 },
                2: { img: '2', quantity: 0 },
                3: { img: '3', quantity: 0 },
                4: { img: '4', quantity: 0 },
                5: { img: '5', quantity: 0 },
                6: { img: '6', quantity: 0 },
                7: { img: '7', quantity: 0 },
                8: { img: '8', quantity: 0 },
                9: { img: '9', quantity: 0 },
                10: { img: '10', quantity: 0 },
                11: { img: '11', quantity: 0 },
                12: { img: '12', quantity: 0 },
                13: { img: '13', quantity: 0 },
                14: { img: '14', quantity: 0 },
                15: { img: '15', quantity: 0 },
                16: { img: '16', quantity: 0 },
                17: { img: '17', quantity: 0 },
                18: { img: '18', quantity: 0 }
            }
        }
    },
    computed: {
        getPartnersData() {
            if (Object.keys(this.partnersData).length === 0) {
                return this.imgListSection2
            } else {
                const data = { ...this.imgListSection2 }
                for (let item in this.partnersData) {
                    data[item]['quantity'] = this.partnersData[item]
                }

                return data
            }
        }
    }
}
</script>

<style scope src="./PartnersSection-light-theme.css"></style>
<style scope src="./PartnersSection-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/public/components/landing-page/partners-section/PartnersSection.vue